/* global axios */
import ApiClient from './ApiClient';

class MedupDealsAPI extends ApiClient {
  constructor() {
    super('integrations/medup', { accountScoped: true });
  }

  deals(page = 1, per = 50, sort = 'created_at', dir = 'desc') {
    return axios.get(`${this.url}/deals`, { params: { page, per, sort, dir } });
  }

  products(dealIds = []) {
    return axios.get(`${this.url}/deal_products`, {
      params: { deal_ids: dealIds.join(',') },
    });
  }
}

export default new MedupDealsAPI();
